import { Injectable } from '@angular/core';
import { FirebaseX } from '@ionic-native/firebase-x/ngx';
import { FIREBASE_CONFIG_KEY } from "src/app/core/constants/app-constants";
import { AppData } from "..";

@Injectable({
  providedIn: 'root'
})
export class FirebaseConfigService {

  constructor(private firebaseX: FirebaseX,) {
    console.log('Firebase Config init');
  }

  async fetchActivate() {
    await this.firebaseX.fetch()
    await this.firebaseX.activateFetched();
    console.log('fetch Activate called');
    const firebaseRemoteConfig = {}
    for (let i = 0; i < Object.keys(FIREBASE_CONFIG_KEY).length; i++) {
      let key = Object.keys(FIREBASE_CONFIG_KEY)[i]
      console.log('Key:: ', key, ' --->', await this.fetchValue(key))
      firebaseRemoteConfig[key] = await this.fetchValue(key)
    }

    console.log('Remote Config', firebaseRemoteConfig);
    AppData.firebaseRemoteConfigSub$.next(firebaseRemoteConfig);
  }

  async fetchValue(key: string) {
    console.log('Fetching Config:', key);
    return await this.firebaseX.getValue(key);
  }
}
